const PAYMENT_AVISTA = "0";

function createIdentifyNFe() {
  return {
    keyAccess: "",
    status: "",
    codeUfEmmiter: "",
    descriptionNatureOperation: "",
    codModelSupervisior: "",
    identifyOperationDestination: "",
    seriesDocumentSupervisior: "",
    numberNfe: "",
    issuanceDateNfe: "",
    issuanceDepartureDate: "",
    operationTypeNfe: "",
    codeCountyOperation: "",
    paperFormart: "",
    typeIssueNfe: "",
    typeKeyAcessVerifier: "",
    environmentalIdentification: "",
    issuePurpose: "",
    endConsumerOperation: "",
    buyerPresenceEstablishment: "",
    indicatorIntermediaryEstablishment: "",
    noteIssuingProcess: "",
    versionOfIssueProcess: "",
    dateAndTimeEntryContingency: "",
    contingencyEntryJustification: "",
    referencedAccessKey: "",
    qrCodeNf: "",
    urlChaveNf: "",
    sinatureNf: "",
    valueBaseTotalCalculeIcms: "",
    valueTotalCalculeIcms: "",
    valueTotalProduct: "",
    valueTotalNF: "",
    valueApproximateTax: "",
    paymentMethodIndicator: "",
    meansOfPayment: "",
    valuePaymentAmount: "",
    typeOfIntegration: "",
    cnpjInstitutionPayment: "",
    valueThing: "",
    valuePaymentAdjustmentTotal: 0,
  };
}

async function execute(sales) {
  try {
    return mounterIdentifyNfe(sales);
  } catch (error) {
    return error;
  }
}

async function mounterIdentifyNfe(sales) {
  let identifyNFe = createIdentifyNFe();
  let DateFormart = await formaterDateSales(sales.data_sale);

  const isLegalPeople = sales.client && sales.client.legalpeople !== null;

  identifyNFe.keyAccess = sales.access_key;
  identifyNFe.status = sales.status;
  identifyNFe.codeUfEmmiter = String(sales.enterprise.address.my_city.state.id);
  identifyNFe.descriptionNatureOperation = "VENDA";
  identifyNFe.codModelSupervisior = 55;
  identifyNFe.identifyOperationDestination = 1;
  identifyNFe.seriesDocumentSupervisior = sales.series;
  identifyNFe.numberNfe = String(sales.number_sale);
  identifyNFe.issuanceDateNfe = DateFormart;
  identifyNFe.issuanceDepartureDate = DateFormart;
  identifyNFe.operationTypeNfe = 1;
  identifyNFe.codeCountyOperation = String(sales.enterprise.address.city_id);
  identifyNFe.paperFormart = "1";
  identifyNFe.typeIssueNfe = "1";
  identifyNFe.typeKeyAcessVerifier = String(1);
  identifyNFe.environmentalIdentification = String(sales.enterprise.note_issuing_environment);
  identifyNFe.issuePurpose = 1;
  identifyNFe.endConsumerOperation = isLegalPeople ? "0" : "1";
  identifyNFe.buyerPresenceEstablishment = 1;
  identifyNFe.indicatorIntermediaryEstablishment = "0";
  identifyNFe.noteIssuingProcess = "0";
  identifyNFe.versionOfIssueProcess = "4.00";
  identifyNFe.dateAndTimeEntryContingency = "";
  identifyNFe.contingencyEntryJustification = "";
  identifyNFe.referencedAccessKey = "";
  identifyNFe.qrCodeNf = "";
  identifyNFe.urlChaveNf = "";
  identifyNFe.sinatureNf = "";
  identifyNFe.valueBaseTotalCalculeIcms = parseFloat(sales.base_cal_icms_total);
  identifyNFe.valueTotalCalculeIcms = parseFloat(sales.value_icms_total);
  identifyNFe.valueTotalProduct = parseFloat(sales.value_total_products);
  identifyNFe.valueTotalNF = parseFloat(sales.value_total_note);
  identifyNFe.valueTotalDescont = sales.value_descount_total;
  identifyNFe.valueApproximateTax = sales.valueApproximateTax;
  identifyNFe.paymentMethodIndicator = sales.paymentMethodIndicator;
  identifyNFe.meansOfPayment = sales.form_of_payments[0].code;
  identifyNFe.valuePaymentAmount = parseFloat(sales.value_total_note);
  identifyNFe.infoPayments = await mounterPaymentFormOfConditionPayment(sales.form_of_payments);
  identifyNFe.typeOfIntegration = 2;
  identifyNFe.cnpjInstitutionPayment = "";
  identifyNFe.valueThing = 0;
  identifyNFe.valuePaymentAdjustmentTotal = sales.value_payment_adjustment_total || 0;
  identifyNFe.infoAdditionalTax = "informacoes para o fisco";
  identifyNFe.infoSupplementaryTax = "    Vendedor : " + sales.seller.physicalpeople.name;

  return identifyNFe;
}

async function mounterPaymentFormOfConditionPayment(formOfPayments) {
  let infoPayments = [];
  formOfPayments.forEach((formOfPayment) => {
    let paymentIndex = {};
    if (formOfPayment.code == PAYMENT_AVISTA) {
      paymentIndex.paymentMethodIndicator = "0";
      paymentIndex.meansOfPayment = formOfPayment.code;
      paymentIndex.valuePaymentAmount = parseFloat(formOfPayment.value_form_payment);
      infoPayments.push(paymentIndex);
    } else {
      paymentIndex.paymentMethodIndicator = "1";
      paymentIndex.meansOfPayment = formOfPayment.code;
      paymentIndex.valuePaymentAmount = parseFloat(formOfPayment.value_form_payment);
      infoPayments.push(paymentIndex);
    }
  });
  return infoPayments;
}

async function formaterDateSales(dateSale) {
  let year = dateSale.getFullYear();
  let day = dateSale.getDate();
  let month = dateSale.getMonth() + 1;
  let hours = dateSale.getHours();
  let minutes = dateSale.getMinutes();
  let seconds = dateSale.getSeconds();

  day = day < 10 ? `0${day}` : day.toString();
  month = month < 10 ? `0${month}` : month.toString();
  hours = hours < 10 ? `0${hours}` : hours.toString();
  minutes = minutes < 10 ? `0${minutes}` : minutes.toString();
  seconds = seconds < 10 ? `0${seconds}` : seconds.toString();

  return year + "-" + month + "-" + day + " " + hours + ":" + minutes + ":" + seconds;
}

module.exports = { execute };
